import { useState, FC, MouseEvent } from 'react'
import { noop } from 'lodash-es'
import Button from '@components/Button'
import ClassicSharerContainer from '../../../sharing/containers/ClassicSharerContainer'
import { ShareActionProps } from '../../types'

const ShareAction: FC<ShareActionProps> = props => {
  const { resourceId, resourceType, onDone = noop } = props

  const [sharerVisible, setSharerVisible] = useState(false)

  const toggleShareVisibility = () => {
    const nextVal = !sharerVisible
    setSharerVisible(nextVal)
    if (nextVal === false) {
      onDone()
    }
  }

  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    toggleShareVisibility()
  }

  let content = null

  if (sharerVisible) {
    switch (resourceType) {
      case 'Timeline':
        content = (
          <ClassicSharerContainer
            shareableId={resourceId}
            shareableType={resourceType}
            show={sharerVisible}
            onClose={toggleShareVisibility}
          />
        )
        break

      default:
        content = <div className="p">This resource can&apos;t be shared.</div>
    }
  }

  return (
    <>
      <Button onClick={handleClick} className="button-reset popover-menu-button">
        Share
      </Button>
      {content}
    </>
  )
}

export default ShareAction
